export default __webpack_public_path__ + "static/markus-daum@2x-962efea7038256a4c3131c5b9199b6cb.png";